module.exports = __webpack_public_path__ + "img/bg-steps.7bee077e.png";